import { useField } from "formik";
import { InputField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

export const StaticFoldernameRule: React.FC = () => {
    const { t } = useTranslation();

    const [{ value: type }] = useField("type");

    if (type !== "Static") {
        return null;
    }

    return (
        <InputField
            name="value"
            label={t("designMappings.actions.foldernameRules.form.label.value")}
        />
    );
};